import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { isArray } from "util";
import { getDobDate } from "../common/DisplayDate";

const getOfflineDriverLicenseDetail = (props) => {
  const rows = [];
  const mvrTree = _.get(props.data, "mvrTree");

  if (props.data && mvrTree) {
    const recordRpts = _.get(mvrTree, "recordRpt");
    const recordTypeZero = _.filter(recordRpts, (f) => f.recordType[0] === "0");
    const recordTypeOne = _.filter(recordRpts, (f) => f.recordType[0] === "1");
    const recordTypeTwo = _.filter(recordRpts, (f) => f.recordType[0] === "2");
    const recordTypeThree = _.filter(
      recordRpts,
      (f) => f.recordType[0] === "3"
    );
    if (recordTypeTwo !== undefined) {
      let recTwo = recordTypeTwo;
      if (isArray(recordTypeTwo)) {
        recTwo = recordTypeTwo[0];
      }
      rows.push(
        <Table.Row key={`mvr_req_name`}>
          <Table.Cell colSpan={2} className={"offline-driver-col"}>
            {_.get(recTwo, "recordData[0].nameString[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`mvr_lic_name`}>
          <Table.Cell colSpan={2} className={"offline-driver-col"}>
            {`${_.get(recTwo, "recordData[0].addressStreet[0]", "")} ${_.get(
              recTwo,
              "recordData[0].addressCityStZip[0]",
              ""
            )}`}
          </Table.Cell>
        </Table.Row>
      );
    }

    let recZero = recordTypeZero;
    if (recordTypeZero !== undefined) {
      if (isArray(recordTypeZero)) {
        recZero = recordTypeZero[0];
      }
    }
    let recOne = recordTypeOne;
    if (recordTypeOne !== undefined) {
      if (isArray(recordTypeOne)) {
        recOne = recordTypeOne[0];
      }
    }
    rows.push(
      <Table.Row key={`mvr_lic_num`}>
        <Table.Cell>License Number</Table.Cell>
        <Table.Cell>
          {_.get(recZero, "recordData[0].reportDLN[0]", "")}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_state`}>
        <Table.Cell>License State</Table.Cell>
        <Table.Cell>
          {`${_.get(recZero, "recordData[0].stateId[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_status`}>
        <Table.Cell>License Status</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].licenseStatus[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_class`}>
        <Table.Cell>License Class</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].licenseClass[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_issu_date`}>
        <Table.Cell>Issued Date</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].issuedDate[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_exp_date`}>
        <Table.Cell>Expiration Date</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].expirationDate[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_state`}>
        <Table.Cell>Restrictions</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].restrictions[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_driv_info`}>
        <Table.Cell>Driver&apos;s Info</Table.Cell>
        <Table.Cell>
          {`${_.get(recOne, "recordData[0].driverInfo[0]", "")}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_dob`}>
        <Table.Cell>Date of Birth</Table.Cell>
        <Table.Cell>
          {`${getDobDate(_.get(recZero, "recordData[0].dob[0]"), {
            userAccount: props.userAccount,
          })}`}
        </Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`mvr_lic_rep_data`}>
        <Table.Cell colSpan={2} className={"offline-driver-col"}>
          Report Data
        </Table.Cell>
      </Table.Row>
    );
    const ordRecordTypeThree = _.orderBy(recordTypeThree, (o) =>
      parseInt(_.get(o, "recordData[0].dataSeqN[0]", "0"), 10)
    );
    _.forEach(ordRecordTypeThree, (recThree, index) => {
      rows.push(
        <Table.Row key={`mvr_lic_rep_data_${index}`}>
          <Table.Cell colSpan={2} className={"offline-driver-col"}>
            {_.get(recThree, "recordData[0].dataContents[0]")}
          </Table.Cell>
        </Table.Row>
      );
    });
  }
  return (
    <Table>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};

export default getOfflineDriverLicenseDetail;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineDriverLicenseDetail.js